import { TextField, Box, InputAdornment } from "@mui/material";
import { getFieldLabel } from "../../constants/Helpers";
import HelpText from "../HelpText/HelpText";

function AvgSoakTime({ avgSoakTime, handleChange }) {
  return (
    <Box m={0} width="100%" align="center">
      <h2 className="sectionTitle center">
        {getFieldLabel("effort", "avgSoakTime")}
      </h2>
      <TextField
        name="avgSoakTime"
        variant="standard"
        inputProps={{
          min: 1,
          style: { textAlign: "center" },
        }}
        InputProps={{
          endAdornment: <InputAdornment position="end">hours</InputAdornment>,
        }}
        size="small"
        type="number"
        value={avgSoakTime}
        onChange={handleChange}
      />
      <HelpText helpText={getFieldLabel("effort", "avgSoakTime", "helptext")} />
    </Box>
  );
}

export default AvgSoakTime;
